var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTransporteBus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M20.885 5.868c-.196-1.915-.51-3.407-1.004-3.993-2.04-2.41-16.325-2.587-17.947 0-.397.634-.675 2.12-.862 3.997C.469 5.942 0 6.449 0 7.069v2.347c0 .522.331.962.794 1.133-.11 3.697-.021 7.553.143 9.471 0 1.48.996 1.235.996 1.235h.934v1.598c0 .634.654 1.147 1.46 1.147.808 0 1.462-.513 1.462-1.147v-1.598h10.863v1.598c0 .634.654 1.147 1.462 1.147.806 0 1.46-.513 1.46-1.147v-1.598h.307s1.173.16 1.248-.537c0-1.912.12-6.151.02-10.152.492-.154.851-.606.851-1.15V7.069c0-.635-.491-1.15-1.115-1.2zM5.423 2.218h10.97v1.658H5.422V2.219zm.156 17.15c-.861 0-1.559-.698-1.559-1.557 0-.86.698-1.557 1.56-1.557.86 0 1.559.697 1.559 1.557s-.698 1.557-1.56 1.557zm10.754 0c-.86 0-1.56-.698-1.56-1.557 0-.86.7-1.557 1.56-1.557.862 0 1.56.697 1.56 1.557s-.698 1.557-1.56 1.557zm1.983-6.814H3.499v-7.76h14.817v7.76z",
    transform: "translate(3 2)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransporteBus);
export default __webpack_public_path__ + "static/media/transporte-bus.06c44b86.svg";
export { ForwardRef as ReactComponent };